import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconCalendar = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      viewBox="0 0 20 20"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M11.3822 12.6147C11.8309 12.6147 12.1947 12.2509 12.1947 11.8022C12.1947 11.3535 11.8309 10.9897 11.3822 10.9897C10.9335 10.9897 10.5697 11.3535 10.5697 11.8022C10.5697 12.2509 10.9335 12.6147 11.3822 12.6147Z"
        fill="currentColor"
      />
      <path
        d="M11.3822 9.85437C11.8309 9.85437 12.1947 9.4906 12.1947 9.04187C12.1947 8.59314 11.8309 8.22937 11.3822 8.22937C10.9335 8.22937 10.5697 8.59314 10.5697 9.04187C10.5697 9.4906 10.9335 9.85437 11.3822 9.85437Z"
        fill="currentColor"
      />
      <path
        d="M14.0905 12.6147C14.5392 12.6147 14.903 12.2509 14.903 11.8022C14.903 11.3535 14.5392 10.9897 14.0905 10.9897C13.6417 10.9897 13.278 11.3535 13.278 11.8022C13.278 12.2509 13.6417 12.6147 14.0905 12.6147Z"
        fill="currentColor"
      />
      <path
        d="M14.0905 9.85437C14.5392 9.85437 14.903 9.4906 14.903 9.04187C14.903 8.59314 14.5392 8.22937 14.0905 8.22937C13.6417 8.22937 13.278 8.59314 13.278 9.04187C13.278 9.4906 13.6417 9.85437 14.0905 9.85437Z"
        fill="currentColor"
      />
      <path
        d="M5.96545 12.6147C6.41418 12.6147 6.77795 12.2509 6.77795 11.8022C6.77795 11.3535 6.41418 10.9897 5.96545 10.9897C5.51672 10.9897 5.15295 11.3535 5.15295 11.8022C5.15295 12.2509 5.51672 12.6147 5.96545 12.6147Z"
        fill="currentColor"
      />
      <path
        d="M8.67383 12.6147C9.12256 12.6147 9.48632 12.2509 9.48632 11.8022C9.48632 11.3535 9.12256 10.9897 8.67383 10.9897C8.2251 10.9897 7.86133 11.3535 7.86133 11.8022C7.86133 12.2509 8.2251 12.6147 8.67383 12.6147Z"
        fill="currentColor"
      />
      <path
        d="M5.96545 15.375C6.41418 15.375 6.77795 15.0112 6.77795 14.5625C6.77795 14.1138 6.41418 13.75 5.96545 13.75C5.51672 13.75 5.15295 14.1138 5.15295 14.5625C5.15295 15.0112 5.51672 15.375 5.96545 15.375Z"
        fill="currentColor"
      />
      <path
        d="M8.67383 15.375C9.12256 15.375 9.48632 15.0112 9.48632 14.5625C9.48632 14.1138 9.12256 13.75 8.67383 13.75C8.2251 13.75 7.86133 14.1138 7.86133 14.5625C7.86133 15.0112 8.2251 15.375 8.67383 15.375Z"
        fill="currentColor"
      />
      <path
        d="M11.3822 15.375C11.8309 15.375 12.1947 15.0112 12.1947 14.5625C12.1947 14.1138 11.8309 13.75 11.3822 13.75C10.9335 13.75 10.5697 14.1138 10.5697 14.5625C10.5697 15.0112 10.9335 15.375 11.3822 15.375Z"
        fill="currentColor"
      />
      <path
        d="M6.8125 3C6.8125 2.72386 6.58864 2.5 6.3125 2.5C6.03636 2.5 5.8125 2.72386 5.8125 3V3.625H4.61538C3.44885 3.625 2.5 4.56764 2.5 5.73437V15.3906C2.5 16.5573 3.44885 17.5 4.61538 17.5H15.3846C16.5511 17.5 17.5 16.5573 17.5 15.3906V5.73437C17.5 4.56764 16.5511 3.625 15.3846 3.625H14.1875V3C14.1875 2.72386 13.9636 2.5 13.6875 2.5C13.4113 2.5 13.1875 2.72386 13.1875 3V3.625H6.8125V3ZM5.8125 4.625V5.37499C5.8125 5.65114 6.03636 5.87499 6.3125 5.87499C6.58864 5.87499 6.8125 5.65114 6.8125 5.37499V4.625H13.1875V5.37499C13.1875 5.65114 13.4113 5.87499 13.6875 5.87499C13.9636 5.87499 14.1875 5.65114 14.1875 5.37499V4.625H15.3846C16.0023 4.625 16.5 5.12344 16.5 5.73437V6.25H3.5V5.73437C3.5 5.12344 3.99761 4.625 4.61538 4.625H5.8125ZM3.5 15.3906V7.25H16.5V15.3906C16.5 16.0015 16.0023 16.5 15.3846 16.5H4.61538C3.99761 16.5 3.5 16.0015 3.5 15.3906Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
